import React from "react";
import {Avatar} from "../../../libs/components/Avatar";
import {ResponsiveImage} from "../../../libs/components/ResponsiveImage";
import styled , {keyframes} from "styled-components";
import {FadeIn} from '../../../libs/components/FadeIn';

const fadeIn = keyframes`
  from{
    opacity:0;
  }
  to{
    opacity:1;
  }
`;

const CardHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  color: #fff;
`;

const Title = styled.h1`
  font-size: 48px;
  font-weight: ${(props) => props.titleFontWeight ? parseInt(props.titleFontWeight,10) : 100 };
  margin: 5px;
  color: ${(props) => props.color ? props.color : 'white'};
  animation: ${fadeIn}2s;
`;

const SubTitle = styled.h2`
  font-weight: 300;
  margin: 5px;
  color: ${(props) => props.color ? props.color : 'white'};
`;

const Header = styled.div`
  width: 100%;
  // height: 100%;
  background-image: ${props => (props.img ? "url(" + props.img + ")" : "none")};
  background-size: cover;
  background-repeat: no-repeat;
  clip-path: polygon(0 0, 100% 0, 100% 90%, 50% 100%, 0 90%);
  min-height: 200px;
`;

const HeaderImg = styled.div`
  width: 100%;
  // height: auto;
  // max-width:1200px;
  // max-height:450px;
  // min-height:150px;
  clip-path: polygon(0 0, 100% 0, 100% 90%, 50% 100%, 0 90%);
`;
const HeaderContent = styled.div`
  width: 100%;
  position: relative;
  top: -30px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export default function BusinessCardHeader({
  title,
  subTitle,
  headerImage,
  avatar,
  avatarOffset,
  titleColor,
  titleFontWeight,
  subtitleColor
}) {
  return (
    <CardHeaderContainer>
      <HeaderImg>
        {/* <img
          width="100%"
          alt="Header"
          src={headerImage}
        /> */}
        {
          headerImage.images ?
          <ResponsiveImage width="100%" images={headerImage.images}/>
          :
          null
        }
       
      </HeaderImg>
      <HeaderContent>
        {
          avatar.images ?
          <Avatar images={avatar.images} offset={avatarOffset}/>
          :
          null
        }
        <FadeIn>
          <Title color={titleColor} titleFontWeight={titleFontWeight}>{title}</Title>
        </FadeIn>
        <FadeIn>
          <SubTitle color={subtitleColor} >{subTitle}</SubTitle>
        </FadeIn>
      </HeaderContent>
    </CardHeaderContainer>
  );
}
